import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { TCampaign } from '~/features/campaigns/models'
import { queryKeys } from '~/features/campaigns/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import pathBuilder from '~/utils/api'

const getCampaignById = (id: string) => {
  return HttpService.get<TCampaign>(
    {
      path: pathBuilder(EServerPath.campaign, { id }),
    },
    EHttpService.internal,
  )
}

const useGetCampaignById = (
  id: string,
  queryOptions?: Omit<
    UseQueryOptions<HttpServiceBaseResponse<TCampaign>>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: queryKeys.campaign(id),
    queryFn: () => getCampaignById(id),
    enabled: !!id,
    refetchOnWindowFocus: false,
    ...queryOptions,
    refetchInterval: queryOptions?.refetchInterval || 0,
  })
}

export default useGetCampaignById
